import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';

interface ConfirmProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  danger?: boolean;
}

export default function Confirm({
  open, onClose, onConfirm, title, message,
  confirmLabel = 'Confirmar', danger = false,
}: ConfirmProps) {
  return (
    <Modal open={open} onClose={onClose} title={title} size="sm">
      <div className="flex gap-3 mb-6">
        <AlertTriangle size={20} className="text-warning flex-shrink-0 mt-0.5" />
        <p className="text-text-secondary text-sm font-inter">{message}</p>
      </div>
      <div className="flex justify-end gap-3">
        <button onClick={onClose} className="btn-ghost">Cancelar</button>
        <button onClick={() => { onConfirm(); onClose(); }} className={danger ? 'btn-danger' : 'btn-gold'}>
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
